exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Blk3tcQm_uHlzJMXNH9Kn{font-size:14px;font-weight:400}html[dir] .Blk3tcQm_uHlzJMXNH9Kn{margin:0 8px}", ""]);

// exports
exports.locals = {
	"content": "Blk3tcQm_uHlzJMXNH9Kn"
};